// @flow
import React, { Component } from 'react'
import { browserHistory } from 'react-router'
import queryString from 'query-string'
import { connect } from 'react-redux'
import * as actions from '../actions'
import { isLoggedIn } from '../selectors'
import { loginUrl } from '../routes'
import { Alert, Row, Col, Button } from 'react-bootstrap'
import googleLogo from '../images/google-logo.svg'

class LoginPage extends Component {
  renderSignInError: Function

  props: {
    location: Object,
    params: {
      status: 'success' | 'error',
    },
    fetchAuthIfNeeded: Function,
    isLoggedIn: boolean,
  }

  constructor(props) {
    super(props)
    this.renderSignInError = this.renderSignInError.bind(this)
  }

  componentWillMount() {
    if (this.props.params.status === 'success') {
      this.props.fetchAuthIfNeeded().then(() => {
        if (!this.props.isLoggedIn) {
          browserHistory.replace('/login')
        } else {
          const returnUrl = this.props.location.query.returnUrl
          if (returnUrl) {
            browserHistory.replace(returnUrl)
          } else {
            browserHistory.replace('/')
          }
        }
      })
    }
  }

  renderSignInError() {
    return this.props.params.status === 'error'
      ? <Alert bsStyle="danger">
          There was an error signing in. Please try again.
        </Alert>
      : null
  }

  render() {
    const { status } = this.props.params
    const { location } = this.props
    return (
      <div>
        <Row className="show-grid">
          <Col xs={12} md={12}>
            {status !== 'success'
              ? <div className="text-center">
                  {this.renderSignInError()}
                  <Button
                    href={`${loginUrl}?${queryString.stringify({
                      returnUrl: location.query.returnUrl,
                    })}`}
                  >
                    Sign in with <img src={googleLogo} alt="google logo" />
                  </Button>
                </div>
              : null}
          </Col>
        </Row>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  isLoggedIn: isLoggedIn(state),
})

export default connect(mapStateToProps, actions)(LoginPage)



// WEBPACK FOOTER //
// ./src/pages/LoginPage.js